<template>
  <div>

    <c-title>Projekt vorschlagen</c-title>

    <c-project-form
      @submit="submit"
      @validation="validationStatus = $event"
    />

  </div>
</template>

<script>
import CTitle from '@/components/CTitle'
import CProjectForm from '@/components/project/CProjectForm'

import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'VProjectProposal',

  components: {
    CTitle,
    CProjectForm
  },

  data () {
    return {
      validationStatus: this.$config.status.IDLE
    }
  },

  methods: {
    submit (data) {
      if (this.validationStatus !== this.$config.status.SUCCESS) {
        return
      }

      this.$api.post('projects/project/', data)
        .then(response => {
          this.$store.commit('notifications/add', {
            text: `Ihr Projekt '${response.data.title}' wurde erstellt.`,
            type: 'success'
          })
          this.$router.push({ name: 'dashboard' })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Ihr Projekt kann zurzeit leider nicht erstellt werden. Bitte versuchen Sie es später erneut.'
          })
        })
    }
  }
}
</script>
